"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PortReserveAsset = void 0;
const big_js_1 = __importDefault(require("big.js"));
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const spl_token_registry_1 = require("@solana/spl-token-registry");
const anchor = __importStar(require("@project-serum/anchor"));
const port_sdk_1 = require("@port.finance/port-sdk");
const asset_1 = require("./asset");
const utils_1 = require("../utils");
const utils_2 = require("./utils");
// TODO use constant from port sdk
// WF port team to make it public
// https://github.com/port-finance/port-sdk/blob/v2/src/utils/AssetConfigs.ts
const DEVNET_ASSETS = [
    new port_sdk_1.AssetConfig(port_sdk_1.MintId.fromBase58("So11111111111111111111111111111111111111112"), new port_sdk_1.AssetDisplayConfig("Solana", "SOL", "#BC57C4"), port_sdk_1.AssetPriceConfig.fromDecimals(4), new port_sdk_1.AssetDepositConfig(port_sdk_1.ReserveId.fromBase58("6FeVStQAGPWvfWijDHF7cTWRCi7He6vTT3ubfNhe9SPt"), {
        min: 100000000,
        remain: 20000000, // remain 0.02 SOL
    })),
];
class PortReserveAsset extends asset_1.LendingMarket {
    constructor(provider, accounts, client, reserveToken, lpToken) {
        super();
        this.provider = provider;
        this.accounts = accounts;
        this.client = client;
        this.reserveToken = reserveToken;
        this.lpToken = lpToken;
    }
    static load(provider, cluster, reserveMint) {
        return __awaiter(this, void 0, void 0, function* () {
            let env;
            let market;
            if (cluster == "devnet") {
                env = new port_sdk_1.Environment(spl_token_registry_1.ENV.Devnet, DEVNET_LENDING_PROGRAM_ID, port_sdk_1.PORT_STAKING, spl_token_1.TOKEN_PROGRAM_ID, DEVNET_ASSETS);
                market = new web3_js_1.PublicKey("H27Quk3DSbu55T4dCr1NddTTSAezXwHU67FPCZVKLhSW");
            }
            else if (cluster == "mainnet-beta") {
                env = port_sdk_1.Environment.forMainNet();
                market = port_sdk_1.DEFAULT_PORT_LENDING_MARKET;
            }
            else {
                throw new Error("Cluster ${cluster} not supported");
            }
            const client = new port_sdk_1.Port(provider.connection, env, market);
            const reserveContext = yield client.getReserveContext();
            const reserve = reserveContext.getByAssetMintId(port_sdk_1.MintId.of(reserveMint));
            const [authority, _] = yield web3_js_1.PublicKey.findProgramAddress([market.toBuffer()], env.getLendingProgramPk());
            const accounts = {
                program: env.getLendingProgramPk(),
                market: market,
                marketAuthority: authority,
                reserve: reserve.getReserveId(),
                collateralMint: reserve.getShareMintId(),
                oracle: reserve.getOracleId(),
                liquiditySupply: reserve.getAssetBalanceId(),
            };
            const lpToken = yield (0, utils_2.getToken)(provider.connection, new web3_js_1.PublicKey(reserve.getShareMintId()));
            const reserveToken = yield (0, utils_2.getToken)(provider.connection, new web3_js_1.PublicKey(reserve.getAssetMintId()));
            return new PortReserveAsset(provider, accounts, client, reserveToken, lpToken);
        });
    }
    static initialize(provider, owner, reserveTokenMint, pythPrice, ownerReserveTokenAccount, initialReserveAmount) {
        return __awaiter(this, void 0, void 0, function* () {
            const market = yield createLendingMarket(provider);
            const accounts = yield createDefaultReserve(provider, initialReserveAmount, reserveTokenMint, ownerReserveTokenAccount, market.publicKey, pythPrice, owner);
            const env = new port_sdk_1.Environment(spl_token_registry_1.ENV.Devnet, DEVNET_LENDING_PROGRAM_ID, null, spl_token_1.TOKEN_PROGRAM_ID, []);
            const client = new port_sdk_1.Port(provider.connection, env, market.publicKey);
            const lpToken = yield (0, utils_2.getToken)(provider.connection, accounts.collateralMint);
            const reserveToken = yield (0, utils_2.getToken)(provider.connection, reserveTokenMint);
            return new PortReserveAsset(provider, accounts, client, reserveToken, lpToken);
        });
    }
    getLpTokenAccountValue(address) {
        return __awaiter(this, void 0, void 0, function* () {
            const reserve = yield this.client.getReserve(this.accounts.reserve);
            const exchangeRate = reserve.getExchangeRatio();
            const mint = reserve.getShareMintId();
            const lpToken = new spl_token_1.Token(this.provider.connection, mint, spl_token_1.TOKEN_PROGRAM_ID, web3_js_1.Keypair.generate() // dummy signer since we aren't making any txs
            );
            const lpTokenAmount = port_sdk_1.AssetPrice.of(mint, (yield lpToken.getAccountInfo(address)).amount.toNumber());
            return utils_1.TokenAmount.fromToken(this.reserveToken, lpTokenAmount
                .divide(exchangeRate.getUnchecked())
                .getRaw()
                .round(0, big_js_1.default.roundDown));
        });
    }
    /**
     * @todo make this the same as program's calculation
     *
     * Continuously compounded APY
     *
     * @returns
     */
    getApy() {
        return __awaiter(this, void 0, void 0, function* () {
            const reserve = yield this.client.getReserve(this.accounts.reserve);
            const apr = reserve.getSupplyApy().getUnchecked();
            const apy = Math.expm1(apr.toNumber());
            return new utils_1.Rate((0, big_js_1.default)(apy));
        });
    }
    getBorrowedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const reserve = yield this.client.getReserve(this.accounts.reserve);
            const borrowed = reserve.getBorrowedAsset();
            // Need to round here because the SDK returns a non-int value
            // and retaining that value might cause problems for the fn caller
            return utils_1.TokenAmount.fromToken(this.reserveToken, borrowed.getRaw().round());
        });
    }
    getDepositedAmount() {
        return __awaiter(this, void 0, void 0, function* () {
            const reserve = yield this.client.getReserve(this.accounts.reserve);
            const total = reserve.getTotalAsset();
            // Need to round here because the SDK returns a non-int value
            // and retaining that value might cause problems for the fn caller
            return utils_1.TokenAmount.fromToken(this.reserveToken, total.getRaw().round());
        });
    }
}
exports.PortReserveAsset = PortReserveAsset;
const DEVNET_LENDING_PROGRAM_ID = new web3_js_1.PublicKey("pdQ2rQQU5zH2rDgZ7xH2azMBJegUzUyunJ5Jd637hC4");
const TOKEN_ACCOUNT_LEN = 165;
const TOKEN_MINT_LEN = 82;
const RESERVE_LEN = 575;
const LENDING_MARKET_LEN = 258;
const DEFAULT_RESERVE_CONFIG = {
    optimalUtilizationRate: 80,
    loanToValueRatio: 80,
    liquidationBonus: 5,
    liquidationThreshold: 85,
    minBorrowRate: 0,
    optimalBorrowRate: 40,
    maxBorrowRate: 90,
    fees: {
        borrowFeeWad: new anchor.BN(10000000000000),
        flashLoanFeeWad: new anchor.BN(30000000000000),
        hostFeePercentage: 0,
    },
    stakingPoolOption: 0,
    stakingPool: spl_token_1.TOKEN_PROGRAM_ID, // dummy
};
// TODO move to common utils
const createAccount = (provider, space, owner) => __awaiter(void 0, void 0, void 0, function* () {
    const newAccount = web3_js_1.Keypair.generate();
    const createTx = new web3_js_1.Transaction().add(web3_js_1.SystemProgram.createAccount({
        fromPubkey: provider.wallet.publicKey,
        newAccountPubkey: newAccount.publicKey,
        programId: owner,
        lamports: yield provider.connection.getMinimumBalanceForRentExemption(space),
        space,
    }));
    yield provider.send(createTx, [newAccount]);
    return newAccount;
});
function createLendingMarket(provider) {
    return __awaiter(this, void 0, void 0, function* () {
        const lendingMarket = yield createAccount(provider, LENDING_MARKET_LEN, DEVNET_LENDING_PROGRAM_ID);
        yield provider.send((() => {
            const tx = new web3_js_1.Transaction();
            tx.add((0, port_sdk_1.initLendingMarketInstruction)(provider.wallet.publicKey, Buffer.from("USD\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0\0", "ascii"), lendingMarket.publicKey, DEVNET_LENDING_PROGRAM_ID));
            return tx;
        })(), []);
        return lendingMarket;
    });
}
function createDefaultReserve(provider, initialLiquidity, liquidityMint, sourceTokenWallet, lendingMarket, oracle, owner) {
    return __awaiter(this, void 0, void 0, function* () {
        const reserve = yield createAccount(provider, RESERVE_LEN, DEVNET_LENDING_PROGRAM_ID);
        const collateralMintAccount = yield createAccount(provider, TOKEN_MINT_LEN, spl_token_1.TOKEN_PROGRAM_ID);
        const liquiditySupplyTokenAccount = yield createAccount(provider, TOKEN_ACCOUNT_LEN, spl_token_1.TOKEN_PROGRAM_ID);
        const collateralSupplyTokenAccount = yield createAccount(provider, TOKEN_ACCOUNT_LEN, spl_token_1.TOKEN_PROGRAM_ID);
        const userCollateralTokenAccount = yield createAccount(provider, TOKEN_ACCOUNT_LEN, spl_token_1.TOKEN_PROGRAM_ID);
        const liquidityFeeReceiver = yield createAccount(provider, TOKEN_ACCOUNT_LEN, spl_token_1.TOKEN_PROGRAM_ID);
        const [lendingMarketAuthority] = yield web3_js_1.PublicKey.findProgramAddress([lendingMarket.toBuffer()], DEVNET_LENDING_PROGRAM_ID);
        const tx = new web3_js_1.Transaction();
        tx.add(spl_token_1.Token.createApproveInstruction(spl_token_1.TOKEN_PROGRAM_ID, sourceTokenWallet, provider.wallet.publicKey, owner.publicKey, [], initialLiquidity));
        tx.add((0, port_sdk_1.initReserveInstruction)(initialLiquidity, 0, new anchor.BN(0), DEFAULT_RESERVE_CONFIG, sourceTokenWallet, userCollateralTokenAccount.publicKey, reserve.publicKey, liquidityMint, liquiditySupplyTokenAccount.publicKey, liquidityFeeReceiver.publicKey, oracle, collateralMintAccount.publicKey, collateralSupplyTokenAccount.publicKey, lendingMarket, lendingMarketAuthority, provider.wallet.publicKey, provider.wallet.publicKey, DEVNET_LENDING_PROGRAM_ID));
        yield provider.send(tx, [owner]);
        return {
            program: DEVNET_LENDING_PROGRAM_ID,
            market: lendingMarket,
            marketAuthority: lendingMarketAuthority,
            reserve: reserve.publicKey,
            oracle: oracle,
            collateralMint: collateralMintAccount.publicKey,
            liquiditySupply: liquiditySupplyTokenAccount.publicKey,
        };
    });
}
//# sourceMappingURL=port.js.map